import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-cream px-5 pb-16 sm:pb-24" data-id="element-104" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-3xl rounded-4xl border border-sage/30 bg-sage-tint px-7 py-10 text-center sm:px-12 sm:py-12" data-id="element-105" data-mp="1o5q2iivokc11">
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-teal" data-id="element-106" data-mp="1x4l8puyq5m4c">
          <ShieldCheckIcon className="h-6 w-6 text-cream" aria-hidden="true" data-id="element-107" data-mp="19ehege7feyq0" />
        </span>
        <h2 className="mt-6 text-xl font-extrabold uppercase tracking-[0.08em] text-teal sm:text-2xl" data-id="element-108" data-mp="14fxtag0npqyp">
          Get Your Money Back or Keep It
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-ink-soft" data-id="element-109" data-mp="1j6554cw5sbqf">
          Try Yoga With Tina risk-free for 7 days. If it doesn't help you feel more prepared to
          teach your first beginner classes, email us and we'll refund every cent — and you keep the
          material anyway.
        </p>
      </div>
    </section>;
}